/* global Pusher */
// Pusher.logToConsole = true;
var pusher = new Pusher($('meta[name="pusher"]').attr('content'), {
	encrypted: true,
	cluster: $('meta[name="pusher-cluster"]').attr('content')
});

var channel = pusher.subscribe($('meta[name="pusher-channel"]').attr('content'));